// Material
import { styled } from '@mui/material/styles'
import {
  Divider,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material'
import { openSharedMedia } from '$logic/router'
import { SharedMediaIcon } from '$common/icons/shared-media'
import { t } from '$i18n'
import { getRoom } from '$logic/room'

const StyledListItemButton = styled(ListItemButton)`
  height: 50px;
  text-align: inherit;
  box-sizing: border-box;
  padding: 8px 15px;
`

const StyledListItem = styled(ListItem)`
  text-align: inherit;
  padding: 0;
  .MuiTouchRipple-child {
    background-color: #f9f9f9;
  }
`

const StyledListItemIcon = styled(ListItemIcon)`
  min-width: 24px;
  margin-left: 15px;
`

const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  '.MuiTypography-root': {
    ...theme.typography.subtitle3,
  },
}))

const StyledDivider = styled(Divider)`
  &:last-child {
    display: none;
  }
`

interface Props {
  roomId: string
}

export function SharedMediaProfileActionItem({ roomId }: Props) {
  const onSharedMedia = async () => {
    const room = await getRoom(roomId)
    openSharedMedia(roomId)
    analite('CHAT_SHARED_MEDIA_CLICK', { type: room?.type })
  }
  return (
    <>
      <StyledListItem onClick={onSharedMedia}>
        <StyledListItemButton disableGutters>
          <StyledListItemIcon>
            <SharedMediaIcon />
          </StyledListItemIcon>
          <StyledListItemText>
            {t('profile.common.sharedMedia')}
          </StyledListItemText>
        </StyledListItemButton>
      </StyledListItem>

      <StyledDivider />
    </>
  )
}
